import { RadioGroup, theme } from '@chakra-ui/react';
import config from '@common/config';
import { PricingPlan as PricingPlanType } from '@services/appsync/types';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { UI } from 'src/apps/invest/common/shells/UI';
import { PAGES } from '../../constants';
import { useCheckoutCashflowViewModel } from '../../models/CheckoutCashflowViewModel';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import PricingPlan from '../components/PricingPlan';
import { Section } from '../components/Section';

export const CheckoutCashflowPricingPlanPage: React.FC = () => {
  const viewModel = useCheckoutCashflowViewModel();

  function handleFormSubmission() {
    viewModel.setPage(PAGES.confirmation);
  }

  return (
    <UI>
      <PricingPlan.Form onSubmit={handleFormSubmission}>
        <Header
          breadCrumb={
            <Navigation
              links={[
                { label: 'Amount', onClick: () => viewModel.setPage(PAGES.amount) },
                { isCurrent: true, label: 'Pricing Plan' },
              ]}
            />
          }
        />
        <Section
          title="Choose Your Pricing Plan"
          alignItems={'center'}
          maxWidth={'600px'}
          margin="auto"
          textAlign={'center'}
          titleSize={['32px', '32px', '32px', '48px']}
          description={
            <TextBlock as="span">
              We charge a fee for accounts below ${config.MIN_ACCOUNT_BALANCE_FEE_THRESHOLD}. Please select a plan below
              or{' '}
              <TextBlock
                as="span"
                onClick={() => viewModel.setPage(PAGES.amount)}
                style={{ color: theme.colors.blue[500], cursor: 'pointer' }}>
                click here{' '}
              </TextBlock>
              to change your investment amount.
            </TextBlock>
          }>
          <RadioGroup
            display="flex"
            flexDirection={['column', 'column', 'row', 'row']}
            mt="48px"
            gap="20px"
            onChange={(val: PricingPlanType) => viewModel.setPricingPlan(val)}
            value={viewModel.pricingPlan}>
            <PricingPlan.PricingPlanOption
              featured={true}
              label="Annual Plan"
              pricingPlan={PricingPlanType.FIFTY_DOLLARS_PER_YEAR_UNDER_5K}
              description="Save 15% on your fees"
              points={[
                'Includes $50 in bonus rewards',
                'Access to exclusive actively managed real estate strategies',
                "Weekly payouts (when there's profit)",
                'Flexible withdrawal access',
              ]}
            />
            <PricingPlan.PricingPlanOption
              label="Monthly Plan"
              description="Simple fee structure"
              pricingPlan={PricingPlanType.FIVE_DOLLARS_UNDER_5K}
              points={[
                'Access to exclusive actively managed real estate strategies',
                "Weekly payouts (when there's profit)",
              ]}
            />
          </RadioGroup>
        </Section>
        <Section alignItems={'center'}>
          <PricingPlan.SubmitButton isDisabled={!viewModel.pricingPlan} />
        </Section>
      </PricingPlan.Form>
    </UI>
  );
};
